import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';

export class Subcategory extends ModelBase {
  constructor() {
    super();
    this.name = [];
  }

  name: Translation[];
  currentLanguageName: string;

  categoryNameCurrentLanguage: string;

  toString() {
    return this.currentLanguageName;
  }

  nameAndCategoryString() {
    return this.currentLanguageName + ' - ' + this.categoryNameCurrentLanguage;
  }
}
